export enum ENUM_INVOICE_TYPE {
  INVOICE = "invoice",
  ACT = "act",
}
